import * as React from 'react';
import { styled } from '@linaria/react';

import Demo, {
  DemoToggleButtonGroupControl,
} from '@/components/Demo';

function ShapesColorModeToggle() {
  return (
    <Demo
      id="shapes-color-mode-toggle"
      initialValues={{
        colorMode: 'srgb',
      }}
      outputWrapper={null}
      controlPosition="top"
      controls={[
        <DemoToggleButtonGroupControl
          key="colorMode"
          id="colorMode"
          label="Color Mode"
          options={[
            {
              label: 'sRGB',
              value: 'srgb',
            },
            {
              label: 'P3',
              value: 'p3',
            },
          ]}
        />,
        ,
      ]}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
    >
      {({ colorMode }) => {
        return (
          <Wrapper>
            <Image
              alt={
                colorMode === 'p3'
                  ? 'Three of the abstract shapes from the landing page in vibrant P3 colors'
                  : 'Three of the abstract shapes from the landing page, slightly washed out'
              }
              src={
                colorMode === 'p3'
                  ? '/images/whimsical-animations/shapes-p3.png'
                  : '/images/whimsical-animations/shapes-srgb.png'
              }
            />
            <Disclaimer>
              If the two images look the same to you, it’s likely
              because you’re not using a display that supports the P3
              color space.
            </Disclaimer>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;

const Image = styled.img`
  width: 406px;
  max-width: 90%;
  aspect-ratio: 812 / 493;
  margin-inline: auto;
  margin-top: 32px;
  object-fit: contain;
`;

const Disclaimer = styled.p`
  font-size: 1rem;
  color: var(--color-text);
  max-width: 400px;
  margin-inline: auto;
  text-align: center;

  @media (color-gamut: p3) {
    display: none;
  }
`;

export default ShapesColorModeToggle;
